import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2e5fff06 from 'nuxt_plugin_plugin_2e5fff06' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_a853525c from 'nuxt_plugin_plugin_a853525c' // Source: ./plugin.js (mode: 'all')
import nuxt_plugin_toast_e4ace87c from 'nuxt_plugin_toast_e4ace87c' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_image_a6ff87e4 from 'nuxt_plugin_image_a6ff87e4' // Source: ./image.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_229f4e8a from 'nuxt_plugin_cookieuniversalnuxt_229f4e8a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_Vuelidate_384d8988 from 'nuxt_plugin_Vuelidate_384d8988' // Source: ../plugins/Vuelidate.js (mode: 'all')
import nuxt_plugin_vuerangeslider_3ee40530 from 'nuxt_plugin_vuerangeslider_3ee40530' // Source: ../plugins/vue-range-slider.js (mode: 'client')
import nuxt_plugin_vuemask_613243e6 from 'nuxt_plugin_vuemask_613243e6' // Source: ../plugins/vue-mask.js (mode: 'all')
import nuxt_plugin_phoneformat_7ac9284a from 'nuxt_plugin_phoneformat_7ac9284a' // Source: ../plugins/phone-format.js (mode: 'all')
import nuxt_plugin_numberformat_24c7baf3 from 'nuxt_plugin_numberformat_24c7baf3' // Source: ../plugins/number-format.js (mode: 'all')
import nuxt_plugin_getcookiesopt_11b12a60 from 'nuxt_plugin_getcookiesopt_11b12a60' // Source: ../plugins/get-cookies-opt.js (mode: 'all')
import nuxt_plugin_vuemultiselect_3dc575a0 from 'nuxt_plugin_vuemultiselect_3dc575a0' // Source: ../plugins/vue-multiselect.js (mode: 'all')
import nuxt_plugin_popupnotification_2d0aab8d from 'nuxt_plugin_popupnotification_2d0aab8d' // Source: ../plugins/pop-up-notification.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"pdn66","htmlAttrs":{"lang":"ru"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"metadescription","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon.ico"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FOnest-Black.woff2","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FOnest-Bold.woff2","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FOnest-ExtraBold.woff2","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FOnest-Light.woff2","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FOnest-ExtraLight.woff2","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FOnest-Medium.woff2","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FOnest-Regular.woff2","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FOnest-SemiBold.woff2","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FOnest-Thin.woff2","crossorigin":true}],"style":[{"type":"text\u002Fcss","cssText":"\n  @font-face {\n    font-family: \"Onest\";\n    src: url(\u002Ffonts\u002FOnest-Regular.woff2) format(\"woff2\"),\n      url(\u002Ffonts\u002FOnest-Regular.woff) format(\"woff\");\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n  }\n\n  @font-face {\n    font-family: \"Onest\";\n    src: url(\u002Ffonts\u002FOnest-Medium.woff2) format(\"woff2\"),\n      url(\u002Ffonts\u002FOnest-Medium.woff) format(\"woff\");\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n  }\n\n  @font-face {\n    font-family: \"Onest\";\n    src: url(\u002Ffonts\u002FOnest-Semibold.woff2) format(\"woff2\"),\n      url(\u002Ffonts\u002FOnest-Semibold.woff) format(\"woff\");\n    font-weight: 600;\n    font-style: normal;\n    font-display: swap;\n  }\n\n\n  @font-face {\n    font-family: \"Onest\";\n    src: url(\u002Ffonts\u002FOnest-Black.woff2) format(\"woff2\"),\n      url(\u002Ffonts\u002FOnest-Black.woff) format(\"woff\");\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n  }\n\n\n  @font-face {\n    font-family: \"Onest\";\n    src: url(\u002Ffonts\u002FOnest-Bold.woff2) format(\"woff2\"),\n      url(\u002Ffonts\u002FOnest-Bold.woff) format(\"woff\");\n    font-weight: 800;\n    font-style: normal;\n    font-display: swap;\n  }"}],"script":[{"type":"text\u002Fjavascript","body":true,"src":"\u002Fjs\u002Fsourcebuster.min.js","async":true}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2e5fff06 === 'function') {
    await nuxt_plugin_plugin_2e5fff06(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_a853525c === 'function') {
    await nuxt_plugin_plugin_a853525c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_e4ace87c === 'function') {
    await nuxt_plugin_toast_e4ace87c(app.context, inject)
  }

  if (typeof nuxt_plugin_image_a6ff87e4 === 'function') {
    await nuxt_plugin_image_a6ff87e4(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_229f4e8a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_229f4e8a(app.context, inject)
  }

  if (typeof nuxt_plugin_Vuelidate_384d8988 === 'function') {
    await nuxt_plugin_Vuelidate_384d8988(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuerangeslider_3ee40530 === 'function') {
    await nuxt_plugin_vuerangeslider_3ee40530(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_613243e6 === 'function') {
    await nuxt_plugin_vuemask_613243e6(app.context, inject)
  }

  if (typeof nuxt_plugin_phoneformat_7ac9284a === 'function') {
    await nuxt_plugin_phoneformat_7ac9284a(app.context, inject)
  }

  if (typeof nuxt_plugin_numberformat_24c7baf3 === 'function') {
    await nuxt_plugin_numberformat_24c7baf3(app.context, inject)
  }

  if (typeof nuxt_plugin_getcookiesopt_11b12a60 === 'function') {
    await nuxt_plugin_getcookiesopt_11b12a60(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemultiselect_3dc575a0 === 'function') {
    await nuxt_plugin_vuemultiselect_3dc575a0(app.context, inject)
  }

  if (typeof nuxt_plugin_popupnotification_2d0aab8d === 'function') {
    await nuxt_plugin_popupnotification_2d0aab8d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
